export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <circle cx="44" cy="20" r="9" fill="#E2E0D8" />
    <path d="M8 40 L32 16 L56 40 Z" fill="#C81D25" />
    <rect x="16" y="40" width="32" height="12" fill="#E2E0D8" />
    <rect x="29" y="44" width="6" height="8" fill="#07080B" />
  </svg>
);
